import { createFileRoute } from '@tanstack/react-router';

import Loading from '@/_pages/settings/price-frequencies/new/loading';

export const Route = createFileRoute('/_private/settings/price-frequencies/new')({
  component: Loading,
});
